export enum LicenseTypeEnum {
    Headset = 'headset',
    Tablet = 'tablet',
    Combined = 'combined'
}